import React, { FC, useState } from 'react';
import { Button, Input, message } from 'antd';
import * as translations from './strings';
import { getLangKey } from '../../../../../javascript/models/Language';
import styles from './index.module.css';
import { isValidEmailFormat } from 'BugHerdClient/sidebar/views/CreateTask/create_task/right_panel/loginlessTaskInfo';
import { post, put, get } from '../../../utils/fetch';

const strings = translations[getLangKey()];

type Props = {
  projectId: number;
  organizationId: number;
  onFinish: () => void;
  currentUserId: number;
};

export const InviteTeam: FC<Props> = ({
  projectId,
  organizationId,
  onFinish,
  currentUserId
}) => {
  const [emails, setEmails] = useState<string>('');
  const justEmails = emails.replace(' ', '');

  const emailsAreValid = justEmails
    .split(',')
    .filter(email => !!email)
    .every(email => isValidEmailFormat(email.trim()));

  const inviteTeamMembers = async () => {
    try {
      await post(`/projects/${projectId}/add_collaborator`, {
        email_addresses: justEmails,
        role: 'member'
      });
      message.success('Invitations sent successfully');
      await put(`/users/${currentUserId}`, {
        trial_expiry_extension: true,
        organization_id: organizationId,
        project_id: projectId
      });
    } catch (error) {
      message.error('Something went wrong, please try again');
      console.error(error);
    } finally {
      onFinish();
    }
  };

  const onSkip = async () => {
    try {
      await get(`/projects/${projectId}/skip_invite_member`);
      onFinish();
    } catch (error) {
      console.error(error);
      message.error('Something went wrong, please try again');
    }
  };

  return (
    <div className={styles.inviteTeam}>
      <div className={styles.inviteTeamInner}>
        <span className={styles.bonus}>🎁 {strings.bonus}</span>
        <p className={styles.inviteTeamBonusInfo}>
          <strong>{strings.bonusTitle}</strong>
          <br />
          {strings.bonusDescription}
        </p>
        <div className={styles.inviteInputContainer}>
          <Input
            className={styles.inviteTeamBonusInput}
            placeholder={strings.bonusPlaceholder}
            value={emails}
            onChange={e => setEmails(e.target.value)}
          />
          {emails && !emailsAreValid && (
            <span className={styles.invalidEmailsMessage}>
              {strings.invalidEmailsMessage}
            </span>
          )}
        </div>
        <Button
          className={styles.inviteButton}
          type="primary"
          onClick={inviteTeamMembers}
          disabled={!(emails && emailsAreValid)}
        >
          {strings.inviteButtonLabel}
        </Button>
      </div>
      <div className={styles.skip}>
        <p className={styles.dontWantBonus}>{strings.dontWantBonus}</p>
        <Button className={styles.skipButton} type="default" onClick={onSkip}>
          {strings.skipButtonLabel}
        </Button>
      </div>
    </div>
  );
};
